import { GET, URLS, POST, PUT, PATCH, SET_VALUE, DELETE } from '../../utils'
import { types as LoadingTypes } from './loading'
import { types as ToastTypes } from './toast'
import ROUTER from '@/router.js'



export const types = {
  /**
   * 学校列表请求
   */
  FETCH_LIST_SCHOOL: 'SCHOOL/FETCH_LIST_SCHOOL',

  /**
   * 我的学校请求
   */
  FETCH_MY_SCHOOL: 'SCHOOL/FETCH_MY_SCHOOL',

  /**
   * 新建学校请求
   */
  FETCH_CREATE_SCHOOL: 'SCHOOL/FETCH_CREATE_SCHOOL',

  /**
   * 学校详情请求
   */
  FETCH_DETAIL_SCHOOL: 'SCHOOL/FETCH_DETAIL_SCHOOL',

  /**
   * 学校修改请求
   */
  FETCH_UPDATE_SCHOOL: 'SCHOOL/FETCH_UPDATE_SCHOOL',
  
  /**
   * 学校产品列表请求
   */
  FETCH_PRODUCT_LIST: 'SCHOOL/FETCH_PRODUCT_LIST',

  /**
   * 学校成员列表请求
   */
  FETCH_MEMBER_LIST: 'SCHOOL/FETCH_MEMBER_LIST',

  /**
   * 加入学校
   */
  FETCH_JOIN_SCHOOL: 'SCHOOL/FETCH_JOIN_SCHOOL',

  /**
   * 退出学校
   */
  FETCH_QUIT_SCHOOL: 'SCHOOL/FETCH_QUIT_SCHOOL',

  /**
   * 解散学校
   */
  FETCH_DELETE_SCHOOL: 'SCHOOL/FETCH_DELETE_SCHOOL',

  /**
   * 点赞处理事件
   */
  LOAD_LIKE_EVENT: 'SCHOOL/LOAD_LIKE_EVENT',

}

const state = {
  // 列表
  school: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 当前学校
  currentSchool: null,
  // 我的学校(当前登陆者)
  mySchool: null,
  // 学校成员列表
  member: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 学校产品列表
  product: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  }
}

const mutations = {
  set_load_more(state, param) {
    if (param.data_type === types.FETCH_LIST_SCHOOL) {
      state.school.load_more = param.value
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.load_more = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.load_more = param.value
    } 
  },
  set_pagenum(state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_SCHOOL) {
      state.school.page = param.value
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.page = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.page = param.value
    }
  },
  set_list_data(state, param) {
    // param: {"data": [], "data_type":"member"}
    // console.log("param",param)
    let temp_state = null;
    if(param.data_type === types.FETCH_LIST_SCHOOL){
      temp_state = state.school
    }else if(param.data_type === types.FETCH_MEMBER_LIST){
      temp_state = state.member
    }else if(param.data_type === types.FETCH_PRODUCT_LIST){
      temp_state = state.product
    }
    if(temp_state){
      if (temp_state.page === 1) {
        temp_state.data = param.data
      } else {
        temp_state.data = temp_state.data.concat(param.data)
      }
      temp_state.total_count = param.count
    }
  },
  update_list_data(state, param) {
    if (param.data_type === types.FETCH_LIST_SCHOOL) {
      state.school.data.unshift(param.data)
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.data.unshift(param.data)
      state.currentSchool.is_member = true
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.data.unshift(param.data)
    }
  },
  delete_list_data(state, param) {
    if (param.data_type === types.FETCH_LIST_SCHOOL) {
      state.school.data = state.school.data.filter(item => {
        return item.id !== param.data.id
      })
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.data = state.member.data.filter(item => {
        return item.id !== param.data.id
      })
      state.currentSchool.is_member = false
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.data = state.product.data.filter(item => {
        return item.id !== param.data.id
      })
    }
  },
  
  set_current_school(state, param) {
    state.currentSchool = param
  },
  
  set_my_school(state, param) {
    state.mySchool = param
  },

  [types.LOAD_LIKE_EVENT] (state, param) {
    // {"data_type":"", "pk":1}
    let temp_state = state.product
    if (temp_state){
      let pk = param.pk
      let target_item = temp_state.data.find((item, index) => {
        return item.showwork.pk === pk
      })
      if(target_item){
        if (target_item.showwork.islike === true) {
          target_item.showwork['islike'] = false
          target_item.showwork['likes'] -= 1
        } else {
          target_item.showwork['islike'] = true
          target_item.showwork['likes'] += 1
        }
      }
    }
  }
}
const actions = {
  /**
   * 学校列表
   * @param {*} param {"page":1}
   */
  [types.FETCH_LIST_SCHOOL]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_SCHOOL }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_school(param.page)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)

      // 存储最新学校 id
      if (state.school.page === 1 && response.results.length) {
        SET_VALUE("last_school_id", response.results[0].id)
      }
    })
  },

  /**
   * 新建学校
   * @param {*} param {"name":"", "content":"", "logo":""}
   */
  [types.FETCH_CREATE_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_SCHOOL }
    POST(URLS.create_school, param).then(response => {
      // 更新数据源
      commit('update_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 学校详情
   * @param {*} param {"pk":1}
   */
  [types.FETCH_DETAIL_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    GET(URLS.detail_school(pk)).then(response => {
      // 更新数据源
      commit('set_current_school', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 我的学校
   * @param {*} param {"pk":1}
   */
  [types.FETCH_MY_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    GET(URLS.my_school).then(response => {
      // 更新数据源
      commit('set_my_school', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 学校修改
   * @param {*} param {"pk":1, "name":"", "content":"", "logo":""}
   */
  [types.FETCH_UPDATE_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    delete param.pk
    PATCH(URLS.update_school(pk), param).then(response => {
      // 更新数据源
      commit('set_current_school', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 学校成员列表
   * @param {*} param {"page":1, "shcool":1}
   */
  [types.FETCH_MEMBER_LIST]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_member_school(param.page, param.school)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 学校产品列表
   * @param {*} param {"page":1, "school":1}
   */
  [types.FETCH_PRODUCT_LIST]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_PRODUCT_LIST }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_product_school(param.page, param.school)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 加入学校
   * @param {*} param {"pk":1}
   */
  [types.FETCH_JOIN_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }

    let pk = param.pk
    PUT(URLS.join_school, { 'school_id': pk }).then(response => {
      // 更新数据源
      commit('update_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 离开学校
   * @param {*} param {"pk":1}
   */
  [types.FETCH_QUIT_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }

    let pk = param.pk
    PUT(URLS.quit_school, { 'school_id': pk }).then(response => {
      // 更新数据源
      commit('delete_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 解散学校
   * @param {*} param {"pk":1}
   */
  [types.FETCH_DELETE_SCHOOL]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    DELETE(URLS.delete_school(pk)).then(response => {
      // 移除等待动画
      commit(LoadingTypes.HIDE)
      if (window.history.length > 1) {
        ROUTER.go(-1);
      } else if (window.history.length === 1) {
        ROUTER.replace(`/?tag=mentor`)
      }
    })
  },

}
const getters = {
  
}

export default {
  state,
  mutations,
  actions,
  getters
}

